import { message } from "antd"

const fetchSendError = (whereErrorOccured: string, error?: any) =>{
    if (error) console.error(error)
    message.error(`Something went wrong while ${whereErrorOccured}. Please contact support if the problem persists.`, 10)
}

export default fetchSendError